export default __webpack_public_path__ + "static/media/Retrobase.da1603ab.png";